
import React from "react";

const bold_style = {
  fontWeight: "bold",
}

const PershingUSMail = () => {
  return (
    <div>
      <div style={bold_style}>Via U.S. Mail - Checks should be sent to:</div>
      <div style={{marginLeft: "3rem"}}>
        Pershing LLC<br/>
        PO Box 382121<br/>
        Pittsburgh, Pennsylvania 15250-8121
      </div>
    </div>
  )
}

const PershingOvernightMail = () => {
  return (
    <div>
      <div style={bold_style}>Via Overnight Mail - Client checks via overnight mail should be addressed to:</div>
      <div style={{marginLeft: "3rem"}}>
        Pershing LLC<br/>
        Attn: 382121<br/>
        500 Ross Street 154-0455<br/>
        Pittsburgh, Pennsylvania 15262-0001
      </div>
    </div>
  )
}

const PershingMailInstructions = (props) => {
  const account_number = props.account_number;
  return (
    <div>
      <div>
        Make out checks to <b>Pershing, LLC</b> and include your account number <b>{account_number}</b> on the face or memo section of each check.
      </div>
      <div style={{height: "2rem"}}/>
      <PershingUSMail/>
      <div style={{height: "2rem"}}/>
      <PershingOvernightMail/>
    </div>
  )
}

export { PershingUSMail, PershingOvernightMail, PershingMailInstructions };
